import React, {useMemo} from "react";
import {SelectChipInput, SelectChipInputProps} from "~/apps/core/ui/ChipInput/SelectChipInput";
import moment from "moment";


type Value = [Date, Date]


export type DateRangeChipInputProps = Omit<SelectChipInputProps<Value>, "options"> & {}


function isEqualsDateRange(a: Value, b: Value) {
    if (a && b) {
        for (let i = 0; i < a.length; ++i) {
            if (moment(a[i]).startOf("day").diff(moment(b[i]).startOf("day"), "days") != 0) {
                return false;
            }
        }
        return true;
    }
    return a == b;
}


export function getOptions(): SelectChipInputProps<Value>["options"] {
    const today = moment().startOf("day");
    return [
        {
            title: "Ближайшие",
            value: [moment().add(-3, "days").toDate(), moment().add(7, "days").toDate()]
        },
        {
            title: "За неделю",
            value: [today.clone().add(-7, "days").toDate(), today.toDate()]
        },
        {
            title: "За месяц",
            value: [today.clone().add(-31, "days").toDate(), today.toDate()]
        },
        {
            title: "За год",
            value: [today.clone().add(-365, "days").toDate(), today.toDate()]
        },
        {
            title: "За все время",
            value: null
        }
    ];
}


export const DateRangeChipInput = (props: DateRangeChipInputProps) => {
    const options: SelectChipInputProps<Value>["options"] = useMemo(getOptions, []);

    const title = props.title || "Дата прибытия";
    const label = useMemo(() => {
        const option = options.find(option => isEqualsDateRange(option.value, props.value));
        return option ? option.title : title;
    }, [options, props.value, props.title]);

    return (
        <SelectChipInput
            {...props}
            compareFunction={isEqualsDateRange}
            title={title}
            label={label}
            options={options}
        />
    )
}